import eBillHomeApi from '@/api/eBillHome/eBillHomeApi.js';

export default {
	name: 'e-bill-change-email',
	mixins: [],
	extends: {},
	components: {},
	props: ['applyOption', 'applyText'],
	data() {
		return {
			profile: this.$store.state.profile,
			message: null,
			notifyMdn: '',
			email: '',
		};
	},
	computed: {

	},
	watch: {},
	created() {},
	mounted() {
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		async init(){
			let eBType = await eBillHomeApi.getEBType();
			this.email = eBType.email? eBType.email: this.profile.email;
			this.notifyMdn = eBType.sms? eBType.sms: this.profile.mdn;
			this.ebType = eBType.ebType;
		},

		async applMail(){
			//表單驗證
			const isValid = await this.$validator.validate();	
			if(!isValid){
				return;
			}
			//後端驗證
			let ftRes = await eBillHomeApi.applyMailSMS(this.email, null);
			if(!ftRes || !ftRes.valid){
				this.message = ftRes.message;
				$("#myModal").modal('show');
				return;
			}
			this.$router.push({ name: 'e-bill-change-email2', params: {notifyMdn: this.notifyMdn, email: this.email, ebType: this.ebType}});
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/eBill/eBillChangeeMail/eBillChangeeMail.js